// NOTE This file is auto-generated by Contentlayer

import blog__howToSell_3dModelsMdx from './blog__how-to-sell-3d-models.mdx.json' assert { type: 'json' }
import blog__introducingModelsendMdx from './blog__introducing-modelsend.mdx.json' assert { type: 'json' }

export const allPosts = [blog__howToSell_3dModelsMdx, blog__introducingModelsendMdx]
